module.exports = __webpack_public_path__ + "img/chofu_model_on.dfd67a3c.svg";